// node modules
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

// app modules: components
import Image from 'components/Image';
import Link from 'components/Link';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';

// app modules: service
import assets from 'services/assets';
import route from 'services/route';

// assets
import CssAuthors from './Authors.scss';

const AVATAR_DISPLAY_LIMIT = 3;

class Authors extends Component {
  static propTypes = {
    authors: AuthorsProps.authors,
    className: PropTypes.string,
    shouldRenderNames: PropTypes.bool,
  };

  static defaultProps = {
    authors: [],
    className: '',
    shouldRenderNames: true,
  };

  renderNames() {
    const { authors, shouldRenderNames } = this.props;

    if (shouldRenderNames) {
      const items = authors.map((author, authorIndex) => {
        const key = `author-name-${author.id}`;
        const separator = authorIndex > 0 ? ', ' : '';
        const authorName = `${author.first_name} ${author.last_name}`;

        return (
          <Fragment key={key}>
            {separator}
            <Link to={route.person(author.id, author.is_author)}>{authorName}</Link>
          </Fragment>
        );
      });

      return <p className="authors__names">{items.length ? items : <Skeleton width="70px" />}</p>;
    }

    return null;
  }

  renderAvatars() {
    const { authors } = this.props;
    if (authors.length <= AVATAR_DISPLAY_LIMIT) {
      if (!authors.length) {
        return (
          <div className="authors__avatar">
            <Skeleton circle width="45px" height="45px" />
          </div>
        );
      }
      return authors.map(author => {
        const key = `author-avatar-${author.id}`;
        const authorName = (
          <div className="authors__tooltip">
            {author.first_name} {author.last_name}
          </div>
        );
        const srcSet = assets.srcSet(
          author.avatar_name,
          [
            { density: 1, w: 45, h: 45, resize: 'fit-in' },
            { density: 2, w: 90, h: 90, resize: 'fit-in' },
            { density: 3, w: 135, h: 135, resize: 'fit-in' },
          ],
          assets.avatarUrl,
        );
        return (
          <div key={key} className="authors__avatar">
            <Tooltip
              trigger={['hover']}
              mouseLeaveDelay={0}
              mouseEnterDelay={0.75}
              overlay={authorName}
              placement="top"
            >
              <Link to={route.person(author.id, author.is_author)}>
                <Image
                  image={assets.avatarUrl(author.avatar_name, {
                    resize: 'fit-in',
                    width: 45,
                    height: 45,
                  })}
                  srcSet={srcSet}
                  width={45}
                  height={45}
                  shape="circle"
                />
              </Link>
            </Tooltip>
          </div>
        );
      });
    }
    return null;
  }

  render() {
    const { className } = this.props;
    const authorsClassName = classNames('authors', className);

    return (
      <div className={authorsClassName}>
        {this.renderAvatars()}
        {this.renderNames()}
      </div>
    );
  }
}

export default withStyles(CssAuthors)(Authors);
